const rdsharma_soln = [
  { title: "RD Sharma Class 12", link: "/rd-sharma-solutions/class-12/maths" },
  // { title: "RD Sharma Class 11", link: "/rd-sharma-solutions/class-11/maths" },
  // { title: "RD Sharma Class 10", link: "/rd-sharma-solutions/class-10/maths" },
  // { title: "RD Sharma Class 9", link: "/rd-sharma-solutions/class-9/maths" },
  // { title: "RD Sharma Class 8", link: "/rd-sharma-solutions/class-8/maths" },
  // { title: "RD Sharma Class 7", link: "/rd-sharma-solutions/class-7/maths" },
  // { title: "RD Sharma Class 6", link: "/rd-sharma-solutions/class-6/maths" },
];
const class12_soln = [
  {
    title: "NCERT Solutions for Class 12 Maths",
    link: "/ncert-solutions/class-12/maths",
  },
  {
    title: "NCERT Solutions for Class 12 Physics",
    link: "/ncert-solutions/class-12/physics",
  },
  {
    title: "NCERT Solutions for Class 12 Chemistry",
    link: "/ncert-solutions/class-12/chemistry",
  },
  {
    title: "NCERT Solutions for Class 12 Biology",
    link: "/ncert-solutions/class-12/biology",
  },
  {
    title: "NCERT Solutions for Class 12 English",
    link: "/ncert-solutions/class-12/english",
  },
];
const class11_soln = [
  {
    title: "NCERT Solutions for Class 11 Maths",
    link: "/ncert-solutions/class-11/maths",
  },
  {
    title: "NCERT Solutions for Class 11 Physics",
    link: "/ncert-solutions/class-11/physics",
  },
  {
    title: "NCERT Solutions for Class 11 Chemistry",
    link: "/ncert-solutions/class-11/chemistry",
  },
  {
    title: "NCERT Solutions for Class 11 Biology",
    link: "/ncert-solutions/class-11/biology",
  },
];
const class10_soln = [
  {
    title: "NCERT Solutions for Class 10 Maths",
    link: "/ncert-solutions/class-10/maths",
  },
  {
    title: "NCERT Solutions for Class 10 Science",
    link: "/ncert-solutions/class-10/science",
  },
  {
    title: "NCERT Solutions for Class 10 Social Science",
    link: "/ncert-solutions/class-10/social-science",
  },
  {
    title: "NCERT Solutions for Class 10 English",
    link: "/ncert-solutions/class-10/english",
  },
  {
    title: "NCERT Solutions For Class 10 Hindi Sanchayan",
    link: "/ncert-solutions/class-10/hindi-sanchayan",
  },
  {
    title: "NCERT Solutions For Class 10 Hindi Sparsh",
    link: "/ncert-solutions/class-10/hindi-sparsh",
  },
  {
    title: "NCERT Solutions For Class 10 Hindi Kshitiz",
    link: "/ncert-solutions/class-10/hindi-kshitiz",
  },
];
const class9_soln = [
  {
    title: "NCERT Solutions for Class 9 Maths",
    link: "/ncert-solutions/class-9/maths",
  },
  {
    title: "NCERT Solutions for Class 9 Science",
    link: "/ncert-solutions/class-9/science",
  },
  {
    title: "NCERT Solutions for Class 9 Social Science",
    link: "/ncert-solutions/class-9/social-science",
  },
  {
    title: "NCERT Solutions for Class 9 English",
    link: "/ncert-solutions/class-9/english",
  },
];
const class_names = [
  { title: "RD Sharma Solutions" },
  { title: "NCERT Solutions Class 12" },
  { title: "NCERT Solutions Class 11" },
  { title: "NCERT Solutions Class 10" },
  { title: "NCERT Solutions Class 9" },
  { title: "All solutions" },
];
const all_links = [
  ...rdsharma_soln,
  ...class10_soln,
  ...class11_soln,
  ...class9_soln,
  ...class12_soln,
];

module.exports = {
  rdsharma_soln,
  class12_soln,
  class_names,
  class11_soln,
  class10_soln,
  class9_soln,
  all_links,
};